export const formatLevelErrorMessage = (
	template: string,
	requiredLevel?: number | null,
): string => {
	if (requiredLevel && template.includes('%%')) {
		return template.replace('%%', String(requiredLevel));
	}

	return requiredLevel ? `${template} (LVL ${requiredLevel})` : template;
};
